<template>
    <div class="article-box">
        <Title :title="article.title"/>

        <el-menu
        v-if="article.nav"
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(item, index) of article.nav"
            :key="index"
            @click="handleSelect(index)">{{item.label}}</el-menu-item>
        </el-menu>

        <ul class="text-list">
            <li
            v-for="(item, index) in list"
            :key="index">
                <!-- 文章 -->
                <el-link
                v-if="item.url === undefined"
                :href="'/detail--' + item.id + '.html'"
                target="_blank"
                :underline="false"
                v-html="item.title"></el-link>

                <!-- 其他链接 -->
                <el-link
                v-else
                :href="item.url"
                target="_blank"
                :underline="false"
                v-html="item.title"></el-link>

                <p>
                    <i class="el-icon-time"></i>
                    {{item.post_date.split(/T|Z/).join(' ')}}
                </p>
            </li>
        </ul>

        <div
        v-if="article.params && list.length >= article.params.n"
        class="more-box">
            <el-button
            type="primary"
            plain
            @click="getMore()">查看更多</el-button>
        </div>
    </div>
</template>

<script>
import { getTitle } from '../../api'

export default {
    name: 'Article',
    props: ['article'],
    data() {
        return {
            activeIndex: '1',
            name: '',
            list: []
        }
    },
    mounted() {
        // 如果导航不为空
        if(this.article.nav) {
            this.name = this.article.nav[0].value
        }

        // 如果内容是静态的
        if(this.article.list) {
            this.list = this.article.list
            return
        }
        
        getTitle(this.article.params)
        .then(res => {
            this.list = res.list
        })
    },
    methods: {
        handleSelect(index) {
            this.article.params.terms = this.article.nav[index].value
            getTitle(this.article.params)
            .then(res => {
                this.list = res.list
            })
        },
        getMore() {
            window.open('/Index/wjs_search_res.html?kw=' + this.article.params.terms)
        }
    }
}
</script>

<style scoped>
.text-list li {
    line-height: 40px;
    border-bottom: #dcdfe6 dashed 1px;
    margin-top: 10px;
}

.text-list li:last-child {
    border: none;
}

.text-list .el-link {
    font-size: 18px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.text-list p {
    font-size: 14px;
    color: #9f9f9f;
}

.text-list p i {
    margin-right: 5px;
}

@media(max-width: 1100px) {
    .text-list li {
        line-height: 30px;
    }
    
    .text-list .el-link {
        font-size: 16px;
    }
}
</style>
